<template>
    <v-btn
        :block="orientation === 'column'"
        outlined
        class="text-none mx-auto"
        :class="[
            orientation === 'column' ? 'mb-4' : null,
            layout === 'card' ? 'px-4' : 'px-8',
            image ? 'btn-image' : null
         ]"
        :color="isSelected ? 'green darken-2' : '#DADADA'"
        @click.stop="selectValue(value)"
    >
        <template>
            <v-row
                no-gutters
                dense
                align="center"
            >
                <v-col
                    v-if="image && imageOnLeft"
                    cols="4"
                    class="text-left mr-2"
                >
                    <v-img
                        :src="image"
                        contain
                        :aspect-ratio="0.9"
                    />
                </v-col>
                <v-col
                    :cols="image ? 5 : 12"
                    class="my-auto"
                    :class="{
                        'text-left': image,
                        'text-center': !image
                    }"
                >
                    <span
                        class="h3"
                        :class="[
                            isSelected ? 'green-darken-2--text' : 'black--text'
                        ]"

                    >
                        {{ label }}
                    </span>
                    <div
                        v-if="sublabel"
                        class="sublabel"
                    >
                        <label class="grey-text">
                            {{ sublabel }}
                        </label>
                    </div>
                </v-col>
                <v-col
                    v-if="image && !imageOnLeft"
                    cols="4"
                    offset="3"
                    class="text-left"
                >
                    <v-img
                        :src="image"
                        contain
                        :aspect-ratio="2"
                    />
                </v-col>
            </v-row>
        </template>
    </v-btn>
</template>

<script>
    export default {
        name: 'StepBtn',
        props: {
            image: {
                type: String,
                required: false
            },
            label: {
                type: String,
                required: true
            },
            sublabel: {
                type: String,
                required: false
            },
            orientation: {
                type: String,
                required: false
            },
            isSelected: {
                type: Boolean,
                required: false
            },
            value: {
                type: [Number, Boolean],
                required: true
            },
            imageOnLeft: {
                type: Boolean,
                required: false
            },
            layout: {
                type: String,
                required: false
            }
        },
        methods: {
            selectValue(val) {
                this.$emit('select-value', val);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepBtn.vue